import { applySnapshot, flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { Datalist } from 'glamorous';
import { Indictment } from './models/Indictment';

export const IndictmentCount = types.model({
  apbNumber: types.string,
  name: types.string,
  planningId: types.number,
  cnt: types.number,
});

export const IndictmentStore = types
  .compose(
    getBaseStore<Instance<typeof Indictment>, Instance<typeof Indictment>>(Indictment, 'indictmentId', 'indictment'),
    types.model('IndictmentStore', {
      indictmentCount: types.array(IndictmentCount),
    }),
  )
  .views((self) => ({
    getIndictmentList() {
      return Datalist;
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);

    const getIndictments = flow(function*(data: any) {
      console.log('get indictments');
      const result = yield env.api.get('Planning/getIndictments', { params: data });
      if (result != null) {
        self.putInStore(result);
      }
    });

    const getIndictmentsCount = flow(function*(planningId: number) {
      const result = yield env.api.get('Planning/getIndictmentsCount/' + planningId);
      if (result != null) {
        applySnapshot(self.indictmentCount, result);
      }
    });

    return {
      getIndictments,
      getIndictmentsCount,
    };
  });

export type IndictmentStoreType = typeof IndictmentStore.Type;
